import { render, staticRenderFns } from "./Sensor.vue?vue&type=template&id=5741084a&scoped=true"
import script from "./Sensor.vue?vue&type=script&lang=js"
export * from "./Sensor.vue?vue&type=script&lang=js"
import style0 from "./Sensor.vue?vue&type=style&index=0&id=5741084a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5741084a",
  null
  
)

export default component.exports